import { AsyncContainerModule } from "inversify";
import {
  InsightConfiguracaoGateway,
  InsightConfiguracaoGatewayDi
} from "../services/InsightConfiguracaoGateway";
import { InsightConfiguracaoGatewayAdapter } from "../services/InsightConfiguracaoGatewayAdapter";

export const insightsConfiguracaoContainer = new AsyncContainerModule(
  async (bind) => {
    bind<InsightConfiguracaoGateway>(InsightConfiguracaoGatewayDi).to(
      InsightConfiguracaoGatewayAdapter
    );
  }
);
